<script setup>
import { storeToRefs } from "pinia";
import PasoCotizacionFinalizada from "./components/PasoCotizacionFinalizada";
import PasoGenerales from "./components/PasoGenerales";
import PasoInformacionActivo from "./components/PasoInformacionActivo";
import PasoPersonalEmpresa from "./components/PasoPersonalEmpresa";

import usePublicStore from "@/store/public";

const {
  mostrarPasoDatos,
  mostrarPasoDatosEmpresa,
  mostrarPasoDatosActivo,
  mostrarPasoCotFinalizada,
} = storeToRefs(usePublicStore());
</script>

<template>
  <div>
    <PasoGenerales v-if="mostrarPasoDatos" />
    <PasoPersonalEmpresa v-if="mostrarPasoDatosEmpresa" />
    <PasoInformacionActivo v-if="mostrarPasoDatosActivo" />
    <PasoCotizacionFinalizada v-if="mostrarPasoCotFinalizada" />
  </div>
</template>
